/* eslint-disable @atlaskit/platform/no-module-level-eval, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values  */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
// AFP-2532 TODO: Fix automatic suppressions below
// eslint-disable-next-line @atlassian/tangerine/import/entry-points
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { type Theme } from '../../theme/types';
import { fg } from '@atlaskit/platform-feature-flags';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SidebarWrapper = styled.div<{ theme?: Theme }>(
	{
		minWidth: fg('project-pages-zoom-accessibility') ? '10%' : '320px',
		maxWidth: fg('project-pages-zoom-accessibility') ? '35%' : 'none',
		width: '320px',
		position: 'relative',
		overflowY: 'auto',
		zIndex: 10,
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ theme }: { theme?: Theme }) =>
		theme?.overrideStyles?.sidebarWrapper
			? `background-color: ${theme.overrideStyles.sidebarWrapper.backgroundColor};
  border: ${theme.overrideStyles.sidebarWrapper.border};
  border-radius: ${theme.overrideStyles.sidebarWrapper.borderRadius};
  box-shadow: ${theme.overrideStyles.sidebarWrapper.boxShadow};
  height: ${theme.overrideStyles.sidebarWrapper.height};
  margin: ${theme.overrideStyles.sidebarWrapper.margin};
  padding: ${theme.overrideStyles.sidebarWrapper.padding};`
			: `height: 100%;
  padding: 0 0 0 ${token('space.200', '16px')};
  ${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
  border-left: 1px solid ${token('color.border', colors.N30)};
  background-color: ${token('elevation.surface', '#fff')};`,
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
export const Title = styled.h2`
	font: ${token('font.heading.small')};
	margin: 0;
	padding-top: ${token('space.300')};
	padding-left: ${token('space.200', '16px')};
	color: ${token('color.text')};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
export const Subtitle = styled.div`
	font: ${token('font.body.small')};
	font-weight: ${token('font.weight.bold')};
	margin-top: ${token('space.050', '4px')};
	margin-left: ${token('space.200', '16px')};
	color: ${token('color.text.subtle', colors.N60)};
	text-transform: uppercase;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HeaderContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'&.is-disabled': {
		color: token('color.text.disabled', '#091E42'),
		opacity: token('opacity.disabled', '0.5'),
	},
});
